module.exports = __webpack_public_path__ + "static/img/banner_3.80124d8e.jpg";